/**
 * Per-module inspect analytics.
 */
import React from "react";
import { Icon } from '@iconify/react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import VText from "form/VText";
import BTable from 'components/BTable';
import VButton from 'form/VButton';
import { useAsterController } from 'context';
import { actionModuleInspectList } from 'context/action';
import BGPagination from 'components/BGPagination';
import { getFormatDate } from 'utils/date';
import BPdfExporter from 'components/BPdfExporter';

/**
 * Table of module time spent and quiz scores.
 */
const AnalysisModule = () => {

  const { courseId } = useParams();

  const { t, i18n } = useTranslation('common');

  const [controller, dispatch] = useAsterController();
  const { moduleInspects, loadedDashboard, loadedModuleInspectList } = controller;
  const loading = !loadedDashboard || !loadedModuleInspectList;

  const handlePageChange = (page, pageSize) => actionModuleInspectList(dispatch, { course_id: courseId, page, page_size: pageSize });

  const columns = [
    {
      name: <VText>{t('Date')}</VText>,
      selector: row => row.date,
      cell: rw => <VText>{getFormatDate(rw.date, i18n.language)}</VText>,
      grow: 2
    },
    {
      name: <VText>{t('Module Title')}</VText>,
      selector: row => row.details.module_title,
      cell: rw => <VText>{rw.details.module_title}</VText>,
      grow: 2
    },
    {
      name: <VText>{t('Percent')}</VText>,
      selector: row => row.details.correct_count,
      cell: rw => <VText>{rw.details.total_count ? Math.round(rw.details.correct_count * 100 / rw.details.total_count) : 0} %</VText>
    },
    {
      name: <VText>{t('Quiz Spent')} (min)</VText>,
      selector: row => row.details.quiz_spent,
      cell: rw => <VText>{Math.round(rw.details.quiz_spent / 60)}</VText>
    },
    {
      name: <VText>{t('Total Spent')} (min)</VText>,
      selector: row => row.details.total_spent,
      cell: rw => <VText>{Math.round(rw.details.total_spent / 60)}</VText>
    },
  ];

  return <>

    <Grid container spacing={6} className="mt-6">
      <Grid item sm={12} md={4} className="flex">
        <VText className="text-2xl">{t("Progross by module")}</VText>
      </Grid>
      <Grid item sm={12} md={8} className="flex justify-center md:justify-end flex-wrap items-center">
        <VButton variant="text" color="secondary" className="text-sm normal-case">
          <Icon icon="akar-icons:circle-check" />&nbsp;{t("All status")}
        </VButton>
        <VButton variant="text" color="secondary" className="text-sm ml-2 normal-case">
          <Icon icon="ant-design:filter-filled" />&nbsp;{t('Filter')}
        </VButton>
        <VButton variant="text" color="secondary" className="text-sm ml-2 normal-case">
          <Icon icon="bx:sort" />&nbsp;{t('Sort')}
        </VButton>

        <BPdfExporter
          filename={`${t("Progross by module")}.pdf`}
          title={t("Progross by module")}
          columns={columns}
          rows={moduleInspects.data}
        />
      </Grid>
    </Grid>

    <BTable
      key={loading}
      columns={columns}
      data={moduleInspects.data}
      total={moduleInspects.total}
      loading={loading}
    />

    <BGPagination
      handlePageChange={handlePageChange}
      total={moduleInspects.total}
      initPage={moduleInspects.page}
      initSize={moduleInspects.page_size}
    />
  </>;
};

export default AnalysisModule;